import { jsx as _jsx } from "react/jsx-runtime";
import useFormatCurrency from '../../hooks/useFormatCurrency';
export default function DCurrencyText({ value, className, style, dataAttributes, }) {
    const { values: [valueFormatted] } = useFormatCurrency(value);
    return (_jsx("span", Object.assign({ className: className, style: style }, dataAttributes, { children: valueFormatted })));
}
//# sourceMappingURL=DCurrencyText.js.map